import {ComponentStore} from '@ngrx/component-store';
import {Injectable} from '@angular/core';
import {ReportCardParametersMetricsState} from './report-table-row-parameters-metrics';
import {Observable, switchMap, withLatestFrom} from 'rxjs';
import {MetricComponentObject, MetricComponentObjects} from '../../../../../../shared/classes/metric-component-object';
import {Store} from '@ngrx/store';
import {AppState} from '../../../../../../shared/store/store';
import {filter, tap} from 'rxjs/operators';
import {selectMetricComponentObjects, selectMetricsLoaded} from '../../../../../../shared/store/selectors';

@Injectable()
export class ReportTableRowParametersMetricsStore extends ComponentStore<ReportCardParametersMetricsState> {
  public readonly state$: Observable<ReportCardParametersMetricsState> = this.select((state: ReportCardParametersMetricsState): ReportCardParametersMetricsState => state);
  public readonly metrics$: Observable<MetricComponentObjects> = this.select((state: ReportCardParametersMetricsState): MetricComponentObjects => state.metrics);
  public readonly metric$: Observable<MetricComponentObject | undefined> = this.select((state: ReportCardParametersMetricsState): MetricComponentObject | undefined => state.metric);
  public readonly numberOfMetrics$: Observable<number> = this.select((state: ReportCardParametersMetricsState): number => state.numberOfMetrics);
  public readonly enable$: Observable<boolean> = this.select((state: ReportCardParametersMetricsState): boolean => state.enable);

  private readonly _metricsLoaded: Observable<boolean> = this._store.select(selectMetricsLoaded);
  private readonly _metricComponentObjects: Observable<MetricComponentObjects> = this._store.select(selectMetricComponentObjects);

  private readonly _init: (params: Array<string>) => void = this.effect((params$: Observable<Array<string>>): Observable<[MetricComponentObjects, boolean]> => params$.pipe(
    switchMap((params: Array<string>) => this._metricComponentObjects.pipe(
      withLatestFrom(this._metricsLoaded),
      filter(([_, loaded]: [MetricComponentObjects, boolean]): boolean => loaded),
      tap(([metricComponentObjects]: [MetricComponentObjects, boolean]): void => {
        const metricComponentObjectsFound: MetricComponentObjects = params.reduce((output: MetricComponentObjects, dimension: string) => {
          const metricComponentObject: MetricComponentObject = metricComponentObjects
            .find((metricComponentObject: MetricComponentObject): boolean => metricComponentObject.payload.attributes.slug === dimension);

          if (metricComponentObject) {
            output.push(metricComponentObject);
          }

          return output;
        }, []);

        this.patchState({
          metrics: metricComponentObjectsFound,
          metric: metricComponentObjectsFound[0],
          numberOfMetrics: metricComponentObjectsFound.length && metricComponentObjectsFound.length - 1 || 0,
          enable: metricComponentObjectsFound.length > 0
        });
      })
    ))
  ));

  constructor(
    private readonly _store: Store<AppState>
  ) {
    super({
      metrics: [],
      metric: undefined,
      numberOfMetrics: 0,
      enable: true
    });
  }

  public init(metrics: Array<string>): void {
    this._init(metrics);
  }

}
